/**
 * @author Ariel
 * @description 岗位管理页面配置
 * @Date 2019/12/28
 */
import React from 'react'
import {component_tool, framework_tool} from '../../../tool';
import {WizTableForm} from "../../common";

let {WizModal} = component_tool;
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })

//配置项
let componentName = 'position'
const columns = (positionCategoryList) => {
  return [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "positionCategoryIds",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "orgIds",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "orgList",
    fromItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "岗位分类",
    name: "positionCategoryNames",
    formItem: {
      rules: [{
        required: true,
        message: '请选择岗位分类'
      }],
    },
  },
  {
    title: "岗位名称",
    name: "name",
    searchItem: {},
    tableItem: {
      width: 200
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入岗位名称'
      }]
    },
  },
  {
    title: "岗位编码",
    name: "code",
    searchItem: {},
    tableItem: {
      width: 200
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入岗位编码'
      }]
    }
  },
  {
    title: "岗位状态",
    name: "state",
    dataIndex: "state",
    dict: [
      {code: 1, codeName: '有效'},
      {code: 0, codeName: '无效'}
    ],
    searchItem: {
      type: 'select'
    }
  },
  {
    title: "岗位分类名称",
    name: "positionCategoryId",
    dict: positionCategoryList || [],
    searchItem: {
      type: 'select'
    }
  },
    {
      title: "组织名称",
      name: "belongOrgId",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
        selectType: 'radio'
      }
    },
  {
    title: "岗位分类",
    name: "positionCategoryNames",
    tableItem: {
      width: 350,
    },
  },
  {
    title: "所属组织",
    name: "orgNames",
    tableItem: {
      width: 300,
    }
  },
  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    dict: [
      {code: 1, codeName: '有效'},
      {code: 0, codeName: '无效'}
    ],
    formItem: {
      initialValue: 1,
      type: 'radio'
    }
  },
  {
    title: "所属组织",
    name: "orgNames",
    formItem: {
      rules: [{
        required: true,
        message: '请选择所属组织'
      }]
    }
  }

]};

const templateConfig = (data) => {
  let {positionCategoryList} = data
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(positionCategoryList),
        searchBarProps: {
          buttonSort: ['add', 'delete', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/org/position/positionDetailAdd'
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update', 'enableOrDisable'],
        rowOperateProps: {
          width: 120,
          fixed: 'right',
        },
        rowOperateView: [
          {
            key: "enableOrDisable",
            custom: true,
            params: {children: "启用"},
            textFormat: {
              recordKey: 'state',
              dirt: {'1': '禁用', '0': '启用',}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = record['state'] === 0 ? '您确定要启用该岗位吗？' : '岗位禁用后，所有模块不能使用该岗位，您确定要禁用吗？';
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record['id'],
                      ...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/org/position/positionDetailUpd"
              }
            }
          }
        ]
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
